/**
 * @generated SignedSource<<4120bd4118a057c85aef1be88defc307>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomerScope",
    "kind": "LinkedField",
    "name": "customerViewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "businessId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "orgId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BusinessProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logoUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "botAgentImageUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ChatConfiguration",
        "kind": "LinkedField",
        "name": "chatConfiguration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "themeColor",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WebchatButtonQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WebchatButtonQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b308b6d3b4e4666066c517b5873a26a7",
    "id": null,
    "metadata": {},
    "name": "WebchatButtonQuery",
    "operationKind": "query",
    "text": "query WebchatButtonQuery {\n  customerViewer {\n    id\n    businessId\n    orgId\n    profile {\n      logoUrl\n      botAgentImageUrl\n    }\n    chatConfiguration {\n      themeColor\n    }\n  }\n}\n"
  }
};
})();

node.hash = "151d77b243ecb1465e161f4ff4c6f7ba";

module.exports = node;
